<template>
    <b-card class="contenedor">
        <div slot="header"
             class="text-center font-weight-bold"
        >
            ANÁLISIS DE RIESGOS - TAREAS
        </div>

        <b-row>
            <b-col>
                <label for="company_id">
                    Empresa
                </label>
                <el-select v-model="params.company_id"
                           id="company_id"
                           name="company_id"
                           filterable
                           remote
                           clearable
                           size="small"
                           placeholder="Seleccione una empresa"
                           class="w-100"
                           no-data-text="No hay datos que coincidan"
                           no-match-text="No hay datos que coincidan"
                           :remote-method="fetchCompanies"
                           @change="onCompanyChange"
                >
                    <el-option v-for="company in companies"
                               :key="company.id"
                               :label="company.nombre"
                               :value="company.id"
                    />
                </el-select>
            </b-col>

            <b-col v-if="params.company_id && allCountries.length >= 1">
                <label for="country_id">
                    País
                </label>
                <el-select v-model="country_id"
                           id="country_id"
                           name="country_id"
                           filterable
                           clearable
                           size="small"
                           class="w-100"
                           no-data-text="No hay datos que coincidan"
                           no-match-text="No hay datos que coincidan"
                >
                    <el-option v-for="item in allCountries"
                               :key="item.country.id"
                               :label="item.country.name"
                               :value="item.country.id"
                    />
                </el-select>
            </b-col>

            <b-col v-if="params.company_id">
                <label for="slq_location_id">
                    Ubicación
                </label>
                <tree-select id="slq_location_id"
                             name="slq_location_id"
                             data-vv-as=" "
                             :value="params.slq_location_id"
                             :multiple="false"
                             :defaultExpandLevel="Infinity"
                             :options="treeWithChildrens"
                             :normalizer="normalizer"
                             :show-count="true"
                             value-consists-of="ALL_WITH_INDETERMINATE"
                             @input="setSlqLocationIdToParams"
                             v-validate="'required'"
                             :disabled="!params.company_id"
                />
                <div class="text-danger small"
                     v-text="errors.first('params.slq_location_id')"
                />
            </b-col>

            <b-col>
                <label for="filter">
                    Filtro
                </label>
                <el-input size="small"
                          placeholder="Buscar"
                          v-model="params.filter"
                ></el-input>
            </b-col>

            <b-col>
                <label class="w-100">
                    &nbsp;
                </label>
                <b-button variant="primary"
                          @click="fetchTasks(true)"
                          :disabled="!params.company_id"
                          size="sm"
                          class="mx-1"
                >
                    <i class="fa fa-search"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Buscar'"
                    />
                </b-button>

                <b-button :disabled="!params.company_id"
                          size="sm"
                          @click="resetParams"
                          class="mx-1"
                >
                    <i class="fa fa-eraser"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Limpiar'"
                    />
                </b-button>

                <b-button variant="primary"
                          :disabled="!params.company_id"
                          size="sm"
                          @click="openModalForCreation()"
                          class="float-right mx-1"
                >
                    <i class="fa fa-plus"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Crear'"
                    />
                </b-button>
            </b-col>
        </b-row>

        <b-table hover
                 striped
                 responsive
                 :fields="fields"
                 show-empty
                 empty-text="No hay Tareas para mostrar"
                 :items="tasks.data"
                 class="mt-3"
        >
            <template v-slot:cell(steps_count)="data">
                <b-badge variant="secondary">
                    {{ data.item.steps_count }}
                </b-badge>
            </template>

            <template v-slot:cell(controls_count)="data">
                <b-badge variant="info">
                    {{ data.item.controls_count }}
                </b-badge>
            </template>

            <template v-slot:cell(url)="data">
                <b-img :src="data.item.url"
                       v-if="data.item.url"
                       thumbnail
                       rounded
                       fluid
                       alt="task"
                       style="max-height: 50px; max-width: 50px"
                       @click="setImageSelected(data.item)"
                       class="cursor-pointer"
                />
                <div v-else class="text-muted text-center no-image">
                    Sin imagen
                </div>                            
            </template>

            <template v-slot:cell(actions)="data">
                <el-tooltip popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Descargar"
                >
                    <b-btn variant="info"
                           class="mx-1"
                           size="sm"
                           @click="downloadTask(data.item)"
                    >
                        <i class="fa fa-download"/>
                    </b-btn>
                </el-tooltip>


                <el-tooltip popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Editar"
                >
                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="openModalForEdition(data.item)"
                    >
                        <i class="fa fa-edit"/>
                    </b-btn>
                </el-tooltip>

                <el-tooltip popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Eliminar"
                >
                    <b-btn variant="danger"
                           class="mx-1"
                           size="sm"
                           @click="deleteTask(data.item.id)"
                    >
                        <i class="fa fa-trash"/>
                    </b-btn>
                </el-tooltip>
            </template>
        </b-table>

        <!-- Paginación -->
        <el-pagination v-if="tasks.data && !!tasks.data.length"
                       v-model="params.page"
                       @size-change="fetchTasks(true)"
                       @current-change="fetchTasks()"
                       :current-page.sync="params.page"
                       class="float-right"
                       :page-size.sync="params.per_page"
                       :page-sizes="[10, 30, 50, 100]"
                       layout="total, sizes, prev, pager, next"
                       :total="tasks.total"
        />

        <modal/>
        <modal_image/>
    </b-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

import modal from './modal.vue';
import modal_image from './modal_image.vue';
import TreeSelect from '@riophae/vue-treeselect';
import useCompanyCountries from '../../../composables/country/useCompanyCountries'
import useCompanyLocationsTree from '../../../composables/location/useCompanyLocationsTree'

export default {
    name: 'index',
    mixins: [useCompanyCountries, useCompanyLocationsTree],
    components: {
        TreeSelect,
        modal,
        modal_image
    },
    data() {
        return {
            fields: [
                {
                    key: 'location.description',
                    label: 'Ubicación',
                    thStyle: 'width: 150px; min-width: 150px',
                },
                {
                    key: 'name',
                    label: 'Nombre',
                    thStyle: 'width: 200px; min-width: 200px',
                },
                {
                    key: 'description',
                    label: 'Descripción'
                },
                {
                    key: 'controls_count',
                    label: 'Controles',
                    thStyle: 'width: 90px',
                    tdClass: 'text-center',
                    thClass: 'text-center'
                },
                {
                    key: 'steps_count',
                    label: 'Pasos',
                    thStyle: 'width: 70px',
                    tdClass: 'text-center',
                    thClass: 'text-center'
                },
                {
                    key: 'url',
                    label: 'Imagen'
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                    thStyle: 'width: 120px',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            country_id: null
        };
    },
    computed: {
        ...mapState('tasks', [
            'tasks',
            'params',
            'companies',
        ]),
        ...mapState('configurableVariables', ['allCountries']),
        ...mapState('location', ['treeWithChildrens']),
        ...mapState('autenticacion', ['my_company', 'locations_user'])
    },
    async created() {
        this.resetParams();
        await this.fetchTypes();
        this.load(false);
    },
    methods: {
        ...mapActions('tasks', [
            'fetchCompanies',
            'fetchTasks',
            'fetchTypes',
            'getTask',
            'deleteTask',
            'getLastTask',
            'fetchPositions',
            'downloadTask'
        ]),
        ...mapMutations('tasks', [
            'setModalShow',
            'resetParams',
            'setEditing',
            'resetTask',
            'resetTaskStep',
            'resetTaskControl',
            'setStepToModal',
            'setTask',
            'setModalImage',
            'setSlqLocationIdToParams'
        ]),
        ...mapMutations('dashboard', ['load']),
        ...mapMutations('location', ['resetLocations']),
        async _fetchData() {
            await this.fetchTasks(true);
            await this.fetchPositions();
        },
        normalizer(node) {
            return {
                id: node.id,
                label: node.label,
                children: Array.isArray(node.children) && node.children.length ? node.children : undefined,
                raw: node,
            };
        },
        async onCompanyChange() {
            if (this.params.company_id) {
                this.country_id = null;
                this.setSlqLocationIdToParams(null);
                await this.loadCompanyGeo({ company_id: this.params.company_id, country_id: null });
                
                // Aplicar selección automática después de cargar el árbol
                if (this.locations_user && this.locations_user.length > 0) {
                    const selectedLocationId = await this.loadLocationsTreeWithAutoSelect(this.params.company_id, this.locations_user, null, this.my_company);
                    if (selectedLocationId) {
                        this.setSlqLocationIdToParams(selectedLocationId);
                    }
                }
                
                await this._fetchData();
            } else {
                this.country_id = null;
                this.setSlqLocationIdToParams(null);
                this.resetLocations();
            }
        },
        setImageSelected(data) {
            this.setModalImage({
                show: true,
                data: data
            });
        },
        async openModalForCreation() {
            this.resetTask();
            this.resetTaskStep();
            this.resetTaskControl();
            this.setStepToModal(0);

            this.setEditing(false);
            this.setModalShow(true);
        },
        async openModalForEdition(task) {
            await this.getTask(task.id);
            this.resetTaskStep();
            this.resetTaskControl();

            this.setStepToModal(0);
            this.setEditing(true);
            this.setModalShow(true);
        },
        async openModalAttachments(task) {
            this.setTask(task);
            await this.fetchAttachments(true);
        }
    },
    watch: {
        async country_id(newVal) {
            if (this.params.company_id) {
                if (this.params.slq_location_id) this.setSlqLocationIdToParams(null);
                
                // Cargar ubicaciones con selección automática si el usuario tiene ubicaciones asignadas
                if (this.locations_user && this.locations_user.length > 0) {
                    const selectedLocationId = await this.loadLocationsTreeWithAutoSelect(this.params.company_id, this.locations_user, newVal || null, this.my_company);
                    if (selectedLocationId) {
                        this.setSlqLocationIdToParams(selectedLocationId);
                    }
                } else {
                    await this.loadLocationsTree(this.params.company_id, newVal || null);
                }
            }
        }
    }
};
</script>

<style
    src="../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css"
></style>

<style scoped>

.no-image {
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    border-radius: 4px;
}

</style>